"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKENS = exports.SPACINGS = exports.JUSTIFY = exports.ALIGNS = exports.DIRECTIONS = void 0;
var DIRECTIONS = {
  ROW: "row",
  COLUMN: "column",
  ROWREVERSE: "row-reverse",
  COLUMNREVERSE: "column-reverse"
};
exports.DIRECTIONS = DIRECTIONS;
var ALIGNS = {
  START: "start",
  END: "end",
  CENTER: "center",
  STRETCH: "stretch",
  BASELINE: "baseline"
};
exports.ALIGNS = ALIGNS;
var JUSTIFY = {
  START: "start",
  END: "end",
  CENTER: "center",
  BETWEEN: "between",
  AROUND: "around"
};
exports.JUSTIFY = JUSTIFY;
var SPACINGS = {
  NONE: "none",
  XXXSMALL: "XXXSmall",
  XXSMALL: "XXSmall",
  XSMALL: "XSmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "XLarge",
  XXLARGE: "XXLarge"
};
exports.SPACINGS = SPACINGS;

var TOKENS = function TOKENS(theme) {
  return {
    none: null,
    XXXSmall: theme.orbit.spaceXXXSmall,
    XXSmall: theme.orbit.spaceXXSmall,
    XSmall: theme.orbit.spaceXSmall,
    small: theme.orbit.spaceSmall,
    medium: theme.orbit.spaceMedium,
    large: theme.orbit.spaceLarge,
    XLarge: theme.orbit.spaceXLarge,
    XXLarge: theme.orbit.spaceXXLarge,
    XXXLarge: theme.orbit.spaceXXXLarge
  };
};

exports.TOKENS = TOKENS;